<template>
  <div
    style="
      height: 100vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border-top: 0.5px solid #e2e2e2;
    "
  >
    <van-nav-bar
      :left-text="['/', '/record'].includes(route.path) ? '' : '返回'"
      :left-arrow="!['/', '/record'].includes(route.path)"
      van-nav-bar
      safe-area-inset-top
      @click-left="$router.go(-1)"
    >
      <template #title>
        {{ $store.state.loginUser?.name }}
        <text v-if="$store.state.loginUser?.department_name">{{
          "/" + $store.state.loginUser?.department_name
        }}</text>
      </template>
      <template #right>
        <van-image
          :src="require('@/assets/images/exit.png')"
          style="width: 20px"
          @click="onExit"
        />
      </template>
    </van-nav-bar>
    <div
      van-number-keyboard
      safe-area-inset-bottom
      style="flex: 1; overflow: hidden; padding-bottom: 40px"
    >
      <router-view />
    </div>
    <van-tabbar route safe-area-inset-bottom>
      <van-tabbar-item replace :to="{ name: 'Main' }" icon="home-o">
        待审批
      </van-tabbar-item>
      <van-tabbar-item replace to="/record" icon="search">
        审批记录
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { get_loginuser } from "@/http/api";
import store from "@/store";
import { showConfirmDialog } from "vant";
export default {
  setup() {
    const route = useRoute();
    const state = reactive({});
    onMounted(() => {
      get_loginuser().then((res) => {
        if (res.status == 200) store.commit("setLoginUser", res.data.data);
      });
    });

    const onExit = () => {
      showConfirmDialog({
        title: "退出",
        message: `您确定退出登录吗？`,
        allowHtml: true,
      }).then(() => {
        localStorage.clear();
        window.location.reload();
      });
    };

    return { state, route, onExit };
  },
};
</script>
<style scoped></style>
